// CacheKey b22f7eed7167c31a1b7617283791b414
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-INTERMOUNTAIN": {
    simple_form: {
      labels: {
        encounter: {
          risk_score_2_on_discharge: "High Risk",
          risk_score_3_on_discharge: "Enrolled"
        }
      }
    }
  }
}

